/**
 * File: LoginForm.tsx
 * Path: apps/admin/src/modules/auth/components/LoginForm.tsx
 * Description: Form component for standard login and Google identity. Refactored to remove magic link functionality.
 */

import React from "react";
import { useLoginFormController } from "@/modules/auth/hooks/useLoginFormController";

export const LoginForm: React.FC = () => {
  const { register, onSubmit, errors, isBusy, error, loginWithGoogle } = useLoginFormController();

  return (
    <div className="w-full space-y-stack-xl">
      <form onSubmit={onSubmit} className="space-y-stack-lg">
        <div className="space-y-stack-xs">
          <label
            className="text-xs font-bold uppercase tracking-wider text-muted-foreground"
            htmlFor="email"
          >
            Email Address
          </label>
          <input
            {...register("email")}
            id="email"
            type="email"
            className="w-full rounded-none border-b border-border bg-secondary/50 px-gutter-sm py-stack-sm text-sm text-foreground outline-none transition-colors focus:border-primary focus:bg-secondary"
          />
          {errors.email && (
            <p className="text-xs font-medium text-destructive">
              {errors.email.message}
            </p>
          )}
        </div>

        <div className="space-y-stack-xs">
          <label
            className="text-xs font-bold uppercase tracking-wider text-muted-foreground"
            htmlFor="password"
          >
            Password
          </label>
          <input
            {...register("password")}
            id="password"
            type="password"
            className="w-full rounded-none border-b border-border bg-secondary/50 px-gutter-sm py-stack-sm text-sm text-foreground outline-none transition-colors focus:border-primary focus:bg-secondary"
          />
          {errors.password && (
            <p className="text-xs font-medium text-destructive">
              {errors.password.message}
            </p>
          )}
        </div>

        {error && (
          <div className="rounded-none bg-destructive/10 p-stack-sm text-xs font-medium text-destructive border border-destructive/20">
            {error instanceof Error ? error.message : "Authentication failed"}
          </div>
        )}

        <div className="space-y-stack-sm">
          <button
            type="submit"
            disabled={isBusy}
            className="neuro-bezel w-full py-gutter-sm text-xs font-black uppercase tracking-wider text-primary-foreground bg-primary disabled:opacity-50"
          >
            {isBusy ? "Processing..." : "Access Workspace"}
          </button>
        </div>
      </form>

      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-xs uppercase tracking-tighter">
          <span className="bg-background px-stack-xs text-muted-foreground">
            Or continue with
          </span>
        </div>
      </div>

      <button
        onClick={loginWithGoogle}
        disabled={isBusy}
        type="button"
        className="flex w-full items-center justify-center gap-stack-sm rounded-none border border-border bg-transparent py-stack-sm text-xs font-bold uppercase tracking-wider text-foreground transition-colors hover:bg-secondary"
      >
        Google Identity
      </button>
    </div>
  );
};
